import React from 'react';
import { commonFieldConfig, commonFieldTypes } from '../inputs/field.config';
import FieldTypeSelector from '../inputs/Index';
import AddMoreButton from '../inputs/AddMoreButton';
import { generateImagePath } from '../../../../helpers/helpers';

export default function ImagesGallerySection({
  investmentData,
  handleInputChange,
  dispatch,
  handleAddItem,
  removeItemFromArray,
}) {
  // English Images Gallery Section Fields
  const imagesGallerySectionFieldsEn =
    investmentData.en.imagesGallerySection.images.map((image, index) => ({
      label: `Slider Image URL ${index + 1}`,
      value: image,
      section: 'imagesGallerySection',
      field: 'images',
      index,
      config: { ...commonFieldConfig['en'][commonFieldTypes.media] },
    }));

  return (
    <section className="mb-5">
      <h3 className="mb-3">Images Slider</h3>
      <img
        src={generateImagePath('gallery-section.webp')}
        alt=""
        className="mb-3 w-100"
      />

      <div className="row">
        {/* English Fields */}
        {imagesGallerySectionFieldsEn.map((field, index) => (
          <FieldTypeSelector
            key={index}
            label={field.label}
            fieldName={field.field}
            value={field.value}
            isGallery={true}
            onInputChange={(e) =>
              handleInputChange({
                e,
                section: field.section,
                field: field.field,
                lang: 'en',
                isSameValue: field.config.isSameValue,
                index: field.index,
              })
            }
            config={field.config}
            removeFromList={() =>
              dispatch(
                removeItemFromArray({
                  section: field.section,
                  field: field.field,
                  index,
                }),
              )
            }
          />
        ))}
        <AddMoreButton
          handleAddItem={() => handleAddItem('imagesGallerySection', 'images')}
        />
      </div>
    </section>
  );
}
